import { Plus } from "lucide-react"
import { NavLink } from "react-router"

import { Button } from "@/components/ui/button.tsx"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.tsx"
import DataPointTable from "@/features/datapoints/components/DataPointTable.tsx"

export default function Definitions() {
  return (
    <div className="flex flex-col gap-2 items-start">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="w-[160px] p-6">
            <Plus />
            Add Data Point
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[250px]" align="start">
          <DropdownMenuGroup>
            <NavLink to="/datapoints/defs/new/tag">
              <DropdownMenuItem>
                <Plus />
                Tag Data Point
              </DropdownMenuItem>
            </NavLink>
            <DropdownMenuItem>
              <Plus />
              Derived Data Point
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Plus />
              Discrete Data Point
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      <div className="rounded-md shadow-sm border w-full">
        <DataPointTable variant="page" />
      </div>
    </div>
  )
}
